import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../hooks/useAuthStore";

export default function AdminRoute({ children }) {
  const location = useLocation();
  const { isAuthenticated, isAdmin, isLoading, token } = useAuthStore();

  // While the auth query is still fetching (e.g. on a hard reload),
  // a valid token exists in storage but `user` hasn't resolved yet.
  // Show a spinner instead of immediately redirecting.
  if (isLoading && token) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#61013B]" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/admin/login" replace state={{ from: location }} />;
  }

  if (!isAdmin) {
    return <Navigate to="/user/travel-assistant" replace state={{ from: location }} />;
  }

  return children;
}
